module.exports = __webpack_public_path__ + "static/media/tof-new.0fd5daa9.png";